<template>
  <ul class="grid grid-cols-1 gap-6 sm:grid-cols-2">
    <li
      v-for="flag in flags"
      :key="flag.id"
      class="relative col-span-1 text-gray-900 transition-colors duration-100 bg-gray-100 border-l-4 border-gray-100 divide-y divide-gray-200 rounded-lg shadow hover:bg-gray-200 ease-out-fast"
      :style="{ borderColor: flag.item_color || 'transparent' }"
    >
      <button
        class="flex items-center justify-between w-full p-4 text-left focus:outline-none"
        type="button"
        @click="$emit('toggle', flag)"
      >
        <h3 class="p-0 m-0 font-medium truncate text-md">
          <div>
            {{ flag.item_title }}
          </div>
          <div>
            <div
              v-if="flag.item_starts_at || flag.item_ends_at"
              class="mt-2 text-xs text-gray-700"
            >
              {{ formatAvailability(flag) }}
            </div>
            <div v-else>
              &nbsp;
            </div>
          </div>
        </h3>
      </button>

      <mia-streamline-icon
        v-if="getTooltip(flag)"
        v-tooltip="getTooltip(flag)"
        src="information-circle"
        class="absolute top-0 right-0 w-5 h-5 mt-1 mr-1 text-blue-700 fill-current cursor-help"
        @click.prevent.stop
      />
    </li>
  </ul>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'FlagsList',

  props: {
    car: {
      type: Object,
      required: true
    },

    flags: {
      type: Array,
      required: true
    }
  },

  methods: {
    formatAvailability(flag) {
      if (!flag.item_starts_at && !flag.item_ends_at) {
        return ''
      }

      if (flag.item_starts_at && !flag.item_ends_at) {
        return `ab ${this.formatDate(flag.item_starts_at)}`
      }

      if (!flag.item_starts_at && flag.item_ends_at) {
        return `bis ${this.formatDate(flag.item_ends_at)}`
      }

      return `${this.formatDate(flag.item_starts_at)} - ${this.formatDate(flag.item_ends_at)}`
    },

    formatDate(dateStr) {
      return this.parseDate(dateStr).toFormat('dd.MM.yyyy HH:mm \'Uhr\'')
    },

    parseDate(dateStr) {
      return DateTime.fromFormat(dateStr, 'yyyy-MM-dd HH:mm:ss')
    },

    getTooltip(flag) {
      if (!flag.item_flag_assigned_at) {
        return ''
      }

      return `hinzugefügt von Fabian Groß am ${this.parseDate(flag.item_flag_assigned_at).toFormat('dd.MM.yyyy \'um\' HH:mm \'Uhr\'')}`
    }
  }
}
</script>
